export const diaChiNhanHang = {
  sections: {
    list: { title: 'Delivery info' },
  },
  fields: {
    customerId: 'Customer code',
    customer: 'Customer',
    receiverName: 'Recipient',
    phone: 'Recipient phone',
    address: 'Delivery address',
    region: 'Ward / Province',
    province: 'Province/City',
    ward: 'Ward',
    viDo: 'Latitude',
    kinhDo: 'Longitude',
    coords: 'GPS coordinates',
    coordsFormat: 'Lat: {viDo} · Lng: {kinhDo}',
    default: 'Default delivery',
    defaultYes: 'Default',
    defaultNo: '—',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  filter: {
    searchPlaceholder: 'Recipient, phone or delivery address',
    customerPlaceholder: 'Search customer…',
    defaultAll: 'All',
    defaultYes: 'Default only',
    defaultNo: 'Non-default',
  },
  placeholders: {
    provinceEmpty: '— Select Province/City —',
    wardEmpty: '— Select Ward —',
    addressSearch: 'Type at least 2 characters to search address',
    addressNoOptions: 'No address suggestions',
    viDo: 'e.g. 10.7769',
    kinhDo: 'e.g. 106.7009',
  },
  titles: { add: 'Add delivery info', edit: 'Edit delivery info' },
  inline: {
    itemTitle: 'Delivery info',
  },
  messages: {
    noData: 'No data',
    loadError: 'Failed to load data',
    invalidContext: 'A valid customer ID is required in the URL.',
    customerRequired: 'Please select a customer.',
    createSuccess: 'Delivery info created',
    updateSuccess: 'Delivery info updated',
    deleteSuccess: 'Delivery info deleted',
    notFound: 'Delivery info not found',
    confirmDelete: 'Delete delivery info «{name}»?',
    listSummary: '{count} delivery profiles',
  },
}
